// src/components/home/AdmissionsSection/AdmissionsSection.js
import React from 'react';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
    faPhone,
    faArrowRight,
    faChild,
    faLocationDot,
    faCalendarDays
} from '@fortawesome/free-solid-svg-icons';
import { faWhatsapp } from '@fortawesome/free-brands-svg-icons';
import { trackCallClick, trackWhatsAppClick } from '../../../utils/tracking';
import './AdmissionsSection.css';

const AdmissionsSection = () => {
    const programs = [
        { name: 'Toddler', age: '18mo+', color: '#14B8A6' },
        { name: 'Playgroup', age: '2yr+', color: '#0D7C53' },
        { name: 'Nursery', age: '3yr+', color: '#D4A012' },
        { name: 'LKG', age: '4yr+', color: '#0D7C53' },
        { name: 'UKG', age: '5yr+', color: '#14B8A6' }
    ];

    return (
        <section className="admissions" id="admissions">
            {/* Background elements */}
            <div className="admissions__bg">
                <div className="admissions__orb admissions__orb--1"></div>
                <div className="admissions__orb admissions__orb--2"></div>
            </div>

            <div className="admissions__container">
                {/* Header */}
                <div className="admissions__header">
                    <span className="admissions__badge">
                        <span className="admissions__badge-dot"></span>
                        Now Enrolling
                    </span>
                    <h2 className="admissions__title">
                        Admissions Open
                        <span className="admissions__year">2026-27</span>
                    </h2>
                    <p className="admissions__intro">
                        Begin your child's learning journey at Little Elly Kudlu, where
                        every day is an adventure in discovery.
                    </p>
                </div>

                {/* Main Card */}
                <div className="admissions__card">
                    {/* Programs */}
                    <div className="admissions__programs">
                        <h3 className="admissions__programs-title">Programs</h3>
                        <div className="admissions__programs-grid">
                            {programs.map((program, index) => (
                                <div
                                    className="admissions__program"
                                    key={index}
                                    style={{ '--accent': program.color }}
                                >
                                    <FontAwesomeIcon icon={faChild} className="admissions__program-icon" />
                                    <div className="admissions__program-info">
                                        <span className="admissions__program-name">{program.name}</span>
                                        <span className="admissions__program-age">{program.age}</span>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>

                    {/* Divider */}
                    <div className="admissions__divider"></div>

                    {/* Info Grid */}
                    <div className="admissions__info">
                        <div className="admissions__info-item">
                            <FontAwesomeIcon icon={faLocationDot} />
                            <div>
                                <span className="admissions__info-label">Location</span>
                                <span className="admissions__info-value">Little Elly Kudlu, Bengaluru</span>
                            </div>
                        </div>
                        <div className="admissions__info-item">
                            <FontAwesomeIcon icon={faCalendarDays} />
                            <div>
                                <span className="admissions__info-label">Academic Year</span>
                                <span className="admissions__info-value">2026-27</span>
                            </div>
                        </div>
                    </div>

                    {/* CTAs */}
                    <div className="admissions__cta">
                        <a
                            href="https://wa.me/919019829264?text=Hi!%20I'm%20interested%20in%20admissions%20for%20the%202026-27%20academic%20year."
                            className="admissions__btn admissions__btn--whatsapp"
                            target="_blank"
                            rel="noopener noreferrer"
                            onClick={() => trackWhatsAppClick({ location: 'admissions_section' })}
                        >
                            <FontAwesomeIcon icon={faWhatsapp} />
                            <span>Chat on WhatsApp</span>
                        </a>
                        <a
                            href="tel:+919019829264"
                            className="admissions__btn admissions__btn--call"
                            onClick={() => trackCallClick({ location: 'admissions_section' })}
                        >
                            <FontAwesomeIcon icon={faPhone} />
                            <span>+91 90198 29264</span>
                        </a>
                    </div>
                </div>

                {/* Bottom CTA */}
                <Link to="/schools/little-elly-kudlu" className="admissions__explore">
                    <span>Explore Little Elly Kudlu</span>
                    <FontAwesomeIcon icon={faArrowRight} />
                </Link>
            </div>
        </section>
    );
};

export default AdmissionsSection;
